
export enum UnipileStatus {
  OK = 'OK',
  ERROR_STOPPED = 'ERROR /STOPPED',
  CREDENTIALS = 'CREDENTIALS',
  CONNECTING = 'CONNECTING',
  DELETED = 'DELETED',
  CREATION_SUCCESS = 'CREATION_SUCCESS',
  RECONNECTED = 'RECONNECTED',
  SYNC_SUCCESS = 'SYNC_SUCCESS'
}

export type UnipileAccount = {
  type: string;
  created_at: string;
  status: UnipileStatus;
  accountId: string;
  premiumFeatures?: string[];
  _coach: string;
  _organization: string;
  _id: string;
}
